'use strict';

module.exports = ['$scope', '$rootScope', '$modalInstance', 'config', 'OrderSvc', 'ModalSvc', function ($scope, $rootScope, $modalInstance, config, OrderSvc, ModalSvc) {
    // ------------------
    // scope functions
    // ------------------
    $scope.confirmDelete = function () {
        OrderSvc.delete(config.order_id, $scope.$root.plant).success(function (data) {
            $modalInstance.close();
            $rootScope.$broadcast('refresh-signal', data);
        }).error(function (data) {
            console.error(data);
        });
    };

    $scope.cancelClick = function () {
        ModalSvc.orderEditModal.open({order_id: config.order_id});
        $modalInstance.close();
    };

    $scope.title = "Delete Order";
    $scope.message = config.order_dates.length == 1 ? "Are you sure you want to delete this order?" : `This action will delete all ${config.order_dates.length} orders. Are you sure?`;
}];